// test178
(178 && 0);
